import { createFileRoute } from "@tanstack/react-router";
import { DealsScreen } from "../components/relations/DealsScreen";

export const Route = createFileRoute("/_auth/relations/deals")({
  staticData: {
    titleKey: "relations.deals.title",
    breadcrumbKey: "breadcrumb.operate",
    breadcrumbN: 7,
  },
  component: DealsScreen,
});
